@if (openingHoursV2) {
  <div>
    @for (day of days; track day) {
      <div>
        <span class="day-label">{{ formatDay(day) }}:</span>
        <span>{{ formatDayValue(openingHoursV2[day]) }}</span>
      </div>
    }

    @if (openingHoursV2.exceptions?.length) {
      <div class="section-label">Exceptions</div>
      @for (exception of openingHoursV2.exceptions; track exception) {
        <div>
          <span class="day-label">{{ formatPeriod(exception) }}:</span>
          <span>{{ formatExceptionValue(exception) }}</span>
        </div>
      }
    }

    @if (openingHoursV2.additionalInfo) {
      <div class="section-label">Additional info</div>
      <div>{{ openingHoursV2.additionalInfo }}</div>
    }
  </div>
}
